<template>
    <v-container>
        <v-row>
            <v-col>
                <h4 class="text-h4">Item Group - {{ data.name }}</h4>
                <p class="text-subtitle-1">Item Group Information</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn block depressed @click="navigateToEdit" v-if="hasPermission(perm.item_group.update)">
                    <v-icon left>mdi-pencil</v-icon>
                    update information
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn block depressed color="error--text" v-if="hasPermission(perm.item_group.delete)" @click="handleRemove" :loading="removeLoading">
                    <v-icon left>mdi-delete</v-icon>
                    delete
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="6">
                <ItemGroup :value="data" v-if="!loading"/>                
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-subheader>
                    Subgroups
                    <v-spacer></v-spacer>
                    <v-btn depressed small color="primary" @click="handleNew" v-if="hasPermission(perm.item_group.create)">
                        <v-icon left>mdi-plus</v-icon>
                        add subgroup
                    </v-btn>
                </v-subheader>
                <v-data-table
                    v-if="!loading"
                    dense
                    disable-sort
                    :headers="subgroupsHeaders"
                    :items="subgroups"
                    :loading="subgroupsLoading"
                    :items-per-page="10"
                    :server-items-length="subgroupsLength"
                    @update:options="fetchSupgroupsAsync"
                    :footer-props="{
                        itemsPerPageOptions: [10, 25, 100]
                    }">
                    <template v-slot:[`item.code`]="{item}">
                        <v-btn icon @click="handleSubgroupDisplay(item)">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        {{item.code}}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions'
import ItemGroup from './../../components/warehouse/ItemGroup.vue'
import PAlert from './../../components/common/PAlert.vue'
import { mapActions, mapGetters } from 'vuex'
import itemGroupService from "./../../services/warehouse/itemGroup";

export default {
    name: "ItemGroupDisplayView",
    components: {
        PAlert,
        ItemGroup,
    },
    data() {
        return {
            breadcrumbsItems: [
                {text: 'Warehouse & Inventory'},
                {text: 'Warehouse'},
                {text: "Display Item Group"}
            ],
            id: null,
            data: null,
            loading: false,
            removeLoading: false,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure",
                callback: null
            },
            perm: permissions,
            tab: 0,
            subgroupsHeaders: [
                { text: "Code", value: "code" },
                { text: "Name", value: "name" },
            ],
            subgroups: [],
            subgroupsLoading: false,
            subgroupsLength: 0,
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            findByID: "stock/itemGroup/findByID",
            index: "stock/itemGroup/list/index",
            snackbar: "ui/snakbar/show"
        }),
        navigateToEdit() {
            this.$router.push({ name: "ItemGroupEdit", params: { id: this.id }})
        },
        getItemGroup() {
            this.loading = true
            this.findByID(this.id).then(response => {
            this.data = response.data 
            }).catch(error => {
            let message = error.response ? error.response.data.message : error
            this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.loading = false;
            })
        },
        handleNew() {
            this.$router.push({ name: "ItemGroupCreate", query: { parent_id: this.id } })
        },
        fetchSupgroupsAsync(options) {
            this.subgroupsLoading = true;
            this.index({...options, parent_id: this.id}).then(response => {
                this.subgroups = response.data.data
                this.subgroupsLength = response.data.count
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.subgroupsLoading = false;
            })
        },
        handleSubgroupDisplay(item) {
            this.$router.push({ name: "ItemGroupDisplay", params: { id: item.id }})
        },
        handleRemove() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to delete?", callback: this.remove};
        },
        remove() {
            this.removeLoading = true;
            itemGroupService.remove(this.data).then(() => {
                this.$router.replace({
                    name: "ItemGroupList"
                })
            }).finally(() => {
                this.removeLoading = false;
            })
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.getItemGroup()
    },
    beforeRouteUpdate(to, from, next) {
        this.subgroups = [];
        this.id = to.params.id;
        this.getItemGroup();
        next()
    }
}
</script>

<style>

</style>